import dayjs from 'dayjs'

const state = {
  hzkzqSubtnoList: [],
  seatwtosList: [],
}

const getters = {
}

const mutations = {
  setHzkzqSubtnoList (state, list) {
    state.hzkzqSubtnoList = list
  },
  setSeatwtosList (state, list) {
    state.seatwtosList = list
  },
}

const actions = {
  searchTaxes ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-taxes', { params }).then(async (res) => {
      res.data.list = await dispatch('format', res.data.list)
      return res
    })
  },
  search ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search', { params })
  },
  searchSeatwtos ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-seatwtos', { params })
  },
  searchHzkzq ({ rootState, commit }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno/search-hzkzq', { params }).then(res => {
      const list = res.data.list.map(item => {
        item.owRackWhsAddrid = item.stDesc.split('-')[1]
        return item
      })
      commit('setHzkzqSubtnoList', list.sort((a, b) => dayjs(b.owRackAt) - dayjs(a.owRackAt)))
      return res
    })
  },
  updateSpup ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/update-spup', params)
  },
  updateCscode711 ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/update-cscode711', params)
  },
  updateSeatwsign ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/ordersubtno/update-seatwsign', params)
  },
  format (_, taxes) {
    taxes = taxes.map(item => {
      let taxText = '不包稅X2'
      const m = String(item.jyoShpMethod)
      if (m === '71' || m === '81' || m === '91') {
        taxText = '不包稅'
      } else if (item.jyoExtraInfo.srInclTax === '1') {
        taxText = '稅金全包'
      } else if (item.jyoExtraInfo.srInclFreq === '1') {
        taxText = '包頻繁稅'
      }

      const isPersonage = !item.jyoExtraInfo.tradevan || String(item.jyoExtraInfo.tradevan.isCompany) === '0'
      const isTaxFree = String(item.ccTax) === '0'
      item.stExtraInfo = item.stExtraInfo || {}
      const hasDeclFile = !!(item.goodscc && item.goodscc.gccExtras && item.goodscc.gccExtras.declFile)
      const hasDutyFile = !!(item.duties && item.duties.length &&
        item.duties.every(d => d.dutyFile && d.dutyFile !== '410'))
      const hasFile = hasDeclFile && (isTaxFree || hasDutyFile)

      const canDownload = !isPersonage && hasFile

      return {
        ...item,
        feDef: {
          taxText,
          isPersonage,
          isTaxFree,
          canDownload,
          hasFile,
        }
      }
    })
    return taxes
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
